export default {
    attempted: 'Tentative | Tentatives',
    needs_attention: 'Requiert attention',
    pending: 'Attente',
    reached: 'Rejoint',
};
